import {useEffect, useState} from "react";
import PropTypes from "prop-types";

const WarningBanner = ({level="warning", text, inLine=false}) => {
    const [textContent, setTextContent] = useState("");

    useEffect(() => {
        setTextContent(text);
    }, [text]);
    
    const handleHide = () => {
        setTextContent("");
    }
    if (textContent === "") return null;
    
    let bgClass= "li-bg-warn-light";
    if (level === "danger") {
        bgClass = "li-bg-danger";
    }
    if (level === "success") {
        bgClass = "li-bg-success";
    }
    
    const inlineClass = inLine ? "li-warning-banner-inline " : "";
    
    return (
        <div className={"li-warning-banner "+inlineClass+bgClass}>
            <div className="row justify-content-between">
                <div className="col-11 text-center align-self-center">
                    <i className="fa fa-exclamation-circle fa-1x mr-2"/>{textContent}</div>
                <div className="col-1 text-right">
                    <i className="fa fa-xmark-circle fa-2x" onClick={handleHide}></i>
                </div>
            </div>
        </div>
    );
}

WarningBanner.propTypes = {
    text: PropTypes.string,
    level: PropTypes.string,
    inLine: PropTypes.bool
}

export default WarningBanner;